import { Component, OnInit } from '@angular/core'
import { ActivatedRoute, Data } from '@angular/router'
import { Page } from 'src/app/shared/interfaces/page.interface'
import { StripHtmlPipe } from 'src/app/shared/pipes/strip-html.pipe'
import { MetaService } from 'src/app/shared/services/meta.service'
import { PageService } from 'src/app/shared/services/page-service/page.service'

@Component({
  selector: 'app-generative-ai-issues',
  templateUrl: './generative-ai-issues.component.html',
  styleUrls: ['./generative-ai-issues.component.scss']
})
export class GenerativeAiIssuesComponent implements OnInit {
  page: Page
  title: string

  tabs: { anchor: string; slug: string }[] = [
    {
      anchor: 'Overview',
      slug: 'overview'
    },
    {
      anchor: 'Benefits',
      slug: 'benefits'
    },
    {
      anchor: 'Risks and Unknowns',
      slug: 'risks-and-unknowns'
    }
  ]

  constructor(
    private pageService: PageService,
    private metaService: MetaService,
    private stripHtmlPipe: StripHtmlPipe,
    private activatedRoute: ActivatedRoute
  ) {}

  async ngOnInit() {
    this.activatedRoute.data.subscribe(async (data: Data) => {
      this.title = data.title
      this.page = await this.pageService.show(data.dynamicPageSlug)

      this.metaService.setTags({
        title: this.page.metaTitle || this.page.title,
        description: this.stripHtmlPipe.transform(
          this.page.metaDescription || this.page.excerpt
        ),
        path: this.page.slug,
        absoluteOgImage: this.page.image
          ? this.page.image.socialCard
          : this.metaService.defaultMeta.absoluteOgImage
      })
    })
  }
}
